export default __webpack_public_path__ + "static/media/Lora-BoldItalic.55bdd07e.ttf";